<template>
  <div class="row q-col-gutter-md lm-progress-bar">
    <slot />
  </div>
</template>

<script>
export default {}
</script>
